import { t } from "i18next";
import { Chip } from "@material-tailwind/react";
import { CustomerType } from "../../../types/customer/customerType";
import { statusColors } from "../../../theme/statusPalette";

interface CustomerStatusBadgeProps {
  status: CustomerType;
  size?: "sm" | "md" | "lg";
  className?: string;
  iconOnly?: boolean;
}

/**
 * Badge coloré pour afficher le statut d'un client (ACTIVE, INACTIVE, PROSPECT)
 * @param status - Statut du client
 * @param size - Taille du badge
 * @param className - Classes CSS additionnelles
 */
export default function CustomerStatusBadge({ 
  status,
  size = "sm",
  className = "",
  iconOnly = false
}: CustomerStatusBadgeProps) {
  const getStyle = (status: CustomerType) => {
    switch (status) {
      case CustomerType.ACTIVE:
        return {
          bg: statusColors["pastel-green"][100],
          dot: statusColors["pastel-green"][500],
          text: statusColors["pastel-green"][800],
        };
      case CustomerType.INACTIVE:
        return {
          bg: statusColors.red[100],
          dot: statusColors.red[500],
          text: statusColors.red[800],
        };
      case CustomerType.PROSPECT:
        return {
          bg: statusColors.yellow[100],
          dot: statusColors.yellow[500],
          text: statusColors.yellow[800],
        };
      default:
        return {
          bg: statusColors["chrono-gray"][100],
          dot: statusColors["chrono-gray"][500],
          text: statusColors["chrono-gray"][800],
        };
    }
  };

  const style = getStyle(status);

  return (
    <Chip
      variant="filled"
      size={size}
      value={
        <div className={`flex items-center justify-center ${iconOnly ? "" : "gap-2"}`}>
          <span 
            className="rounded-full shrink-0" 
            style={{
              width: "8px",
              height: "8px",
              backgroundColor: style.dot,
            }}
          ></span>
          {!iconOnly && <span style={{ color: style.text }}>{t(`client:type.${status?.toLowerCase()}`)}</span>}
        </div>
      }
      style={{ backgroundColor: style.bg }}
      className={`w-fit h-fit rounded-full capitalize font-normal ${iconOnly ? "p-1.5" : "py-1 text-xs"} ${className}`}
    />
  );
}
